import { lotteryAbi } from '@/abi/lotteryAbi'
import useReadContract from './useReadContract'
import { useSelectedGame } from '@/providers/SelectedGameProvider'

export default function useLotteryRead() {
    const { gameContractName, selectedGame } = useSelectedGame()
    const game = useReadContract(gameContractName, lotteryAbi).read
    return {
        selectedGame,
        game
    }
}